<template>
    <div class="question-item" ref="container">
        <div v-for="item in resultList" :key="item.id">
            <div class="question-title">{{ item.indexNo }}. {{ item.content }}</div>

            <div class="list">
                <div @click="onChange(opt)" class="item" v-for="opt in optionMap[item.id]" :key="opt.id">
                    <div
                        class="title"
                        :class="{
                            'success-state': opt.success,
                            'error-state': !opt.success,
                        }"
                    >
                        {{ opt.title }}
                    </div>
                    <div class="content">{{ opt.content }}</div>
                </div>
            </div>
            <Result :question="item" />
        </div>
    </div>
</template>
<script>
import Result from '../Result.vue'

export default {
    components: { Result },
    computed: {
        userAnswerMap() {
            return this.$store.state.paperResult.userAnswerMap
        },
        questionAnalysisMap() {
            return this.$store.state.paperResult.questionAnalysisMap
        },
        resultList() {
            const _list = []
            this.question.childQuestions.forEach((item) => {
                const { state, answer } = this.userAnswerMap[`q-${item.id}`]
                const analysis = this.questionAnalysisMap[`q-${item.id}`]
                let userAnswer = answer || ''
                userAnswer = userAnswer.split('@@').join('、')
                let userAnswerState = state || false
                let successAnswer = analysis.answer.split('@@').join('、')
                _list.push({
                    ...item,
                    userAnswer,
                    userAnswerState,
                    successAnswer,
                })
            })
            return _list
        },
        optionMap() {
            const _optionMap = {}
            this.resultList.forEach((item) => {
                const _list = []
                this.question.options.forEach((i) => {
                    if (i.title === item.successAnswer) {
                        _list.push({ ...i, success: true })
                    } else if (i.title === item.userAnswer) {
                        _list.push({ ...i, success: false })
                    }
                })
                _optionMap[item.id] = _list
            })
            return _optionMap
        },
    },
    props: ['question'],
    data() {
        return {}
    },

    methods: {},
}
</script>
<style lang="scss" scoped>
@import '@/scss/paper.scss';
.list {
    padding-top: 20px;
    .item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .title {
            width: 36px;
            height: 36px;
            border-radius: 42px;
            border: 1px solid #eeeeee;
            color: #999;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 16px;
            flex-shrink: 0;
        }
        .success-state {
            color: #ffff;
            background: $success-color;
            border-color: $success-color;
        }
        .error-state {
            color: #ffffff;
            background: $error-color;
            border-color: $error-color;
        }
        .content {
            font-size: 16px;
            line-height: 1.6em;
            img {
                width: 120px;
            }
        }
    }
}
</style>
